import { render, staticRenderFns } from "./affordMortgage.vue?vue&type=template&id=b649e3d2&"
import script from "./affordMortgage.vue?vue&type=script&lang=js&"
export * from "./affordMortgage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports